import { SET_LINKS, SET_LINKS_LOADING } from './actions'

export const reducer = (state, action) => {
  switch (action.type) {
    case SET_LINKS:
      return { ...state, links: action.payload }
    case SET_LINKS_LOADING:
      return { ...state, loadingLinks: action.payload }
    default:
      return state
  }
}
